import * as React from 'react';
import { DocumentTypeMetadata } from '../../../communications/models/enums/document-type';
import { MessageTypeMetadata } from '../../../communications/models/enums/message-type';
import { AppUtils } from '../../../../utils/app-utils';
import { DealerContact, DealerContactPreference } from '../../../../support/models/dealers/dealer-read';

interface IProps {
    contact : DealerContact;
}

export const DealerContactRow = (props : IProps) => {

    const { contact } = props;

    return <tr className="chi-styled-row">
            <td>{ contact.legacyId }</td>
            <td>{ contact.firstName } { contact.lastName }</td>
            <td>{ contact.emailAddress }</td>
            <td>{ contact.faxNumber.length > 0 ? AppUtils.formatPhone(contact.faxNumber) : 'N/A' }</td>
            <td className="table-cell-center">
                {
                    contact.preferences.map((pref: DealerContactPreference, pIdx : number) => (
                            <div>
                                <span key={ pIdx }>
                                    { DocumentTypeMetadata[pref.documentType].display } 
                                    &nbsp;via&nbsp;
                                    { MessageTypeMetadata[pref.communicationMethod].display }                            
                                </span>
                            </div>
                        ))
                }
            </td>
        </tr>;      
};
